// extracted by mini-css-extract-plugin
export default {"page":"uX-z","cartModal":"vX-z","checkout":"wX-z","placeholder":"xX-z","account":"yX-z"};